import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import Spinner from '../../../../components/spinner/spinner';
import useUploadReport from '../hooks/useUploadReport';
import { REQUEST_CUSTOM_EVENTS } from '../requestConstants';

const UPLOAD_TYPE = {
    BROWSE: 'browse',
    CAPTURE: 'capture',
};

const UploadReport = ({ reqId, closeDialog }) => {
    const { uploading, uploadReport } = useUploadReport();
    const [file, setFile] = useState(null);
    const [uploadType, setUploadType] = useState(UPLOAD_TYPE.BROWSE);

    const handleChange = (event) => {
      setUploadType(event.target.value);
    };

    const handlePrescription = (e) => {
        const fileData = e.target.files[0];
        setFile(fileData);
    };

    const handleUploadReport = async () => {
        if (uploading) return;
        const { err } = await uploadReport({ reqId, reportFile: file });
        if (err) {
            console.error('Error uploading report');
            console.error({err});
            if (err?.cause?.response?.data?.message) {
                Swal.fire('Sorry!', err.cause.response.data.message, 'error');
                return;
            }
            Swal.fire('Something Went Wrong!', '', 'error');
            return;
        }

        Swal.fire('Report uploaded successfully!', '', 'success');
        closeDialog();
        document.dispatchEvent(new CustomEvent(REQUEST_CUSTOM_EVENTS.REFETCH_REQ_DETAILS));
    };

    const selectedFileName = file && file.name;

    const fileChooser = () => {
        const browseFile = (
            <div className='flex-gap'>
                <Button variant='outlined' component='label'>
                    <input
                        type='file'
                        accept='image/png, application/pdf, image/jpeg'
                        hidden={true}
                        onChange={handlePrescription}
                    />
                    Browse Report
                </Button>
                <p className='text-ellipsis' title={selectedFileName}>{selectedFileName}</p>
            </div>
        );

        const captureFile = (
            <div className='flex-gap'>
                <Button variant='outlined' component='label'>
                    <input
                        type='file'
                        accept="image/*"
                        capture="environment"
                        hidden={true}
                        onChange={handlePrescription}
                    />
                    Capture Photo
                </Button>
                <p className='text-ellipsis' title={selectedFileName}>{selectedFileName}</p>
            </div>
        );

        switch (uploadType) {
            case UPLOAD_TYPE.BROWSE:
                return browseFile;

            case UPLOAD_TYPE.CAPTURE:
                return captureFile;

            default:
                return;
        }
    };

    const uploadUi = (
        <>
            <FormControl>
                {/* <FormLabel id="upload-type">Upload Type</FormLabel> */}
                <Typography variant="subtitle1" style={{fontWeight: 'bold'}}> Upload Type </Typography>
                <RadioGroup
                    row
                    aria-labelledby="upload-type"
                    name="upload-type"
                    value={uploadType}
                    onChange={handleChange}
                >
                    <FormControlLabel value={UPLOAD_TYPE.BROWSE} control={<Radio />} label="Browse" />
                    <FormControlLabel value={UPLOAD_TYPE.CAPTURE} control={<Radio />} label="Capture (Mobile Only)" />
                </RadioGroup>
            </FormControl>
            <Divider style={{marginBlock: '1rem'}} />
            {fileChooser()}
        </>
    );

    const uploadBtn = () => {
        const btnDisabled = !file || uploading;
        const btnText = uploading ? <>Uploading...&nbsp;<Spinner /></> : 'Upload';
        return <Button variant='contained' color='primary' disabled={btnDisabled} onClick={handleUploadReport}> {btnText} </Button>;
    };

    return (
        <>
            <DialogContent>
                {uploadUi}
            </DialogContent>
            <DialogActions>
                {uploadBtn()}
            </DialogActions>
        </>
    );
};

UploadReport.propTypes = {
    reqId: PropTypes.number,
    closeDialog: PropTypes.func,
};

const VendorActions = ({requestDetails}) => {
    const [showDialog, setShowDialog] = useState(false);

    if (!requestDetails) return;

    const toggleDialog = (toggle) => () => {
      setShowDialog(toggle);
    };

    const uploadReportDialog = (
        <Dialog open={showDialog} maxWidth='xs' fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>Upload Report</div>
                <IconButton size='small' onClick={toggleDialog(false)}>
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <UploadReport reqId={requestDetails.id} closeDialog={toggleDialog(false)} />
        </Dialog>
    );

    return (
        <>
            {uploadReportDialog}
            <Button variant="contained" onClick={toggleDialog(true)}> Upload Report </Button>
        </>
    );
};

export default VendorActions;

VendorActions.propTypes = {
    requestDetails: PropTypes.object.isRequired,
};